import React from 'react';

const kvCardTones={
  plain:{background:'var(--surface-card)',border:'1px solid var(--border-subtle)'},
  sunken:{background:'var(--surface-sunken)',border:'1px solid transparent'},
  rose:{background:'var(--surface-brand-soft)',border:'1px solid transparent'},
  outline:{background:'transparent',border:'1px solid var(--border-default)'},
  inverse:{background:'var(--surface-inverse)',border:'1px solid var(--border-inverse)'}
};
const kvCardPad={none:'0',sm:'var(--space-5)',md:'var(--space-7)',lg:'var(--space-8)'};

export function Card({tone='plain',padding='md',elevation='xs',interactive=false,style,children,...rest}){
  const [hover,setHover]=React.useState(false);
  const s={borderRadius:'var(--radius-card)',padding:kvCardPad[padding],boxShadow:elevation==='none'?'none':'var(--shadow-'+elevation+')',transition:'var(--transition-surface)',
    ...kvCardTones[tone],
    ...(interactive&&hover?{boxShadow:'var(--shadow-md)',transform:'var(--lift-hover)',borderColor:'var(--border-rose)'}:null),
    cursor:interactive?'pointer':'default',...style};
  return React.createElement('div',{style:s,onMouseEnter:()=>setHover(true),onMouseLeave:()=>setHover(false),...rest},children);
}
